import { Component, OnInit } from "@angular/core";
import { NbMenuItem, NbMenuService } from "@nebular/theme";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subscription, combineLatest } from "rxjs";
import { filter } from "rxjs/operators";
import { logout } from "../../app.actions";
import { AppState } from "../../app.models";

const SidebarItemsFactory = (basePath, t, products: string[]): NbMenuItem[] => {
  const baseMenuItems = [
    {
      title: t.documentation,
      icon: "book-open-outline",
      url: `https://docs.ethinking.de/docs/3.2/index.html`,
      target: "_blank",
    },
    {
      title: t.imprint_title,
      icon: "globe-outline",
      url: `https://ethinking.de/imprint`,
      target: "_blank",
    },
    {
      title: t.terms_title,
      icon: "file-text-outline",
      url: `https://ethinking.de/terms`,
      target: "_blank",
    },
    {
      title: t.privacy_title,
      icon: "shield-outline",
      url: `https://ethinking.de/privacy`,
      target: "_blank",
    },
    {
      title: t.logout,
      icon: "power-outline",
      data: "logout",
    },
  ];
  const pushMenuItems: NbMenuItem[] = [
    {
      title: "Home",
      icon: "home-outline",
      link: `/${basePath}/home`,
    },
    {
      title: "Apps",
      icon: "grid-outline",
      link: `/${basePath}/apps`,
      pathMatch: "prefix",
    },
    {
      title: "Tags",
      icon: "pricetags-outline",
      link: `/${basePath}/tags`,
      pathMatch: "prefix",
    },
    {
      title: t.support,
      icon: "at-outline",
      link: `/${basePath}/support`,
    },
  ];
  const analyticsMenuItems: NbMenuItem[] = [
    {
      title: "Analytics",
      icon: "activity-outline",
      link: `/${basePath}/analytics`,
      pathMatch: "prefix",
    },
  ];

  if (products) {
    if (products.includes("push") && products.includes("analytics")) {
      return pushMenuItems.concat(analyticsMenuItems, baseMenuItems);
    } else if (products.includes("push")) {
      return pushMenuItems.concat(baseMenuItems);
    } else if (products.includes("analytics")) {
      return analyticsMenuItems.concat(baseMenuItems);
    }
  }
  return baseMenuItems;
};

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  items: NbMenuItem[];
  contract$: Subscription;
  allContracts: any[];
  avilableProducts: string[];

  constructor(
    private nbMenuService: NbMenuService,
    private store: Store,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.items = [];

    this.contract$ = this.store
      .select((state: AppState) => state.contract)
      .pipe(filter((c) => !!c.selectedContract))
      .subscribe(({ contracts, selectedContract }) => {
        this.allContracts = [...contracts];
        const sameClientIdContracts = this.allContracts.filter(
          (contract) => contract.clientId === selectedContract
        );
        const products = sameClientIdContracts.map((item) => item.product);
        this.avilableProducts = [...products];
      });

    combineLatest([
      this.translate.getTranslation(this.translate.getBrowserLang()),
      this.store.select((state: AppState) => state.contract.selectedContract),
    ]).subscribe(([t, c]) => {
      this.items = SidebarItemsFactory(c, t, this.avilableProducts);
    });

    this.nbMenuService.onItemClick().subscribe((menuBag) => {
      if (menuBag.item.data === "logout") this.store.dispatch(logout());
    });
  }
}
